import {IRoutesMetadata} from '@shared/models/seo/routes-metadata';
import {GameDetailRoutes} from '@app/routes/game-detail.routes';

export const GameDetailRoutesMetadata: IRoutesMetadata = {
  '/': {
    title: '{{eventname}} | fan.at',
    description: 'Hier findest du den Liveticker zum Spiel: {{eventname}} auf fan.at! ' +
      'Alle Tore, Wechsel, Karten, Aufstellungen und Infos zum Match!',
  },
  [GameDetailRoutes.liveTicker]: {
    title: '{{eventname}} | fan.at',
    description: 'Hier findest du den Liveticker zum Spiel: {{eventname}} auf fan.at! ' +
      'Alle Tore, Wechsel, Karten, Aufstellungen und Infos zum Match!',
  },
  [GameDetailRoutes.overview]: {
    title: '{{eventname}} | fan.at',
    description: 'Hier findest du die Übersicht zum Spiel: {{eventname}} auf fan.at! Anpiff, ' +
      'Stadion und Schiedsrichter und alle Infos zum Match!',
  },
  [GameDetailRoutes.videos]: {
    title: '{{eventname}} | fan.at',
    description: 'Hier findest du alle Videos und Highlights zum Spiel: {{eventname}} ' +
      'auf fan.at! Livestream, Tore und Videos zum Match!',
  },
  [GameDetailRoutes.lineup]: {
    title: '{{eventname}} | fan.at',
    description: 'Hier findest du die Aufstellung zum Spiel: {{eventname}} auf fan.at! Formationen und ' +
      'Ersatzspieler, die ganze Aufstellung zum Match!',
  },
}
